import { UPDATE_PARENT_PROJECT, UPDATE_PARENT_PROJECT_SUCCESS, UPDATE_PARENT_PROJECT_ERROR, UPDATE_PARENT_PROJECT_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateParentProject = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PARENT_PROJECT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_PARENT_PROJECT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_PARENT_PROJECT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_PARENT_PROJECT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateParentProject;
